import styled from '@emotion/styled';
import colors from '../../OrderEntry/css/colors';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  border: none;
  cursor: pointer;
  margin-left: auto;
  margin-top: 10px;
`;
export const ActualContent = styled.div`
  padding: 35px 35px;
  max-height: 650px;
  overflow-y: auto;
`;
export const Header = styled.div`
  font-size: 20px;
  line-height: 34px;
  color: #4d4e4d;
  padding: 0px 35px 16px 35px;
  margin-top: 23px;
`;
export const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  justify-content: flex-end;
  border-top: 1px solid #e5e5ea;
  padding-top: 24px;
  padding-bottom: 24px;
`;
export const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 127px;
  height: 47px;
  cursor: pointer;
`;
export const ConfirmButton = styled.button`
  background: #444;
  border: 1px solid #444;
  border-radius: 5px;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  width: 127px;
  height: 47px;
  cursor: pointer;
  margin-right: 35px;
`;
export const ModalHeader = styled.span`
  display: flex;
  border-bottom: 1px solid #e5e5ea;
  background: buttonface;
  border-radius: 5px 5px 0px 0px;
`;
export const Input = styled.input`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  height: 42px;
  width: 280px;
  margin-right: 8px;
  margin-top: 8px;
  padding-left: 8px;
  :focus {
    outline: none;
  }
  ::placeholder {
    color: ${colors.grey400};
  }
`;
export const InputLabel = styled.label`
  font-size: 18px;
`;
export const FlexDiv = styled.div`
  display: flex;
`;
export const FlexColumnDiv = styled(FlexDiv)`
  flex-direction: column;
`;
export const FlexColumnRightDiv = styled(FlexColumnDiv)`
  margin-left: auto;
`;
export const FlexSpan = styled.span`
  display: flex;
`;
export const FlexColumnSpan = styled(FlexSpan)`
  flex-direction: column;
`;
export const ErrorText = styled.div`
  font-size: 15px;
  color: ${colors.hudsonRed};
  margin-top: auto;
  margin-bottom: auto;
`;
export const PropertyAddressText = styled.span`
  margin-left: 8px;
  font-size: 15px;
  font-weight: bold;
`;
